import { useState, type FormEvent } from 'react';
import { useAuth } from './lib/auth';

export function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setErro(null);
    setBusy(true);
    try {
      await login(email, senha);
    } catch {
      setErro('E-mail ou senha inválidos.');
      setBusy(false);
    }
  };

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit}>
        <img src="/assets/logo.png" alt="Bela Vista II" />
        <div className="login-brand">BELA VISTA II</div>
        <div className="login-sub">Sistema Financeiro — SPE Bela Vista 2</div>

        {erro && <div className="login-err">{erro}</div>}

        <div className="field">
          <label>E-mail</label>
          <input className="input" type="email" autoComplete="username" value={email}
            onChange={(e) => setEmail(e.target.value)} required autoFocus />
        </div>
        <div className="field" style={{ marginBottom: 24 }}>
          <label>Senha</label>
          <input className="input" type="password" autoComplete="current-password" value={senha}
            onChange={(e) => setSenha(e.target.value)} required />
        </div>
        <button className="btn dark block" type="submit" disabled={busy}>
          {busy ? 'Entrando…' : 'Entrar'}
        </button>
      </form>
    </div>
  );
}
